export { CircularGraphComponent } from './circular-graph.component';
